export default {
  // Search
  drawTime: 'Draw Time',
  startTime: 'Start Time',
  endTime: 'End Time',
  member_keyword: 'User Info',
  member_keywordPlaceholder: 'Enter user name or UID',
  code: 'Code',
  codePlaceholder: 'Enter QR code, anti-counterfeit code or serial code',
  is_award: 'Win Status',
  is_awardPlaceholder: 'Please select',
  is_awardWon: 'Won',
  is_awardNotWon: 'Not Won',
  activity_keyword: 'Activity Info',
  activity_keywordPlaceholder: 'Enter activity name or ID',
  country_id: 'Scan Country/Region',
  country_idPlaceholder: 'Please select',
  search: 'Search',
  // Table columns
  colUserInfo: 'User Info',
  colQrcode: 'QR Code',
  colActivityInfo: 'Activity Info',
  colWinStatus: 'Win Status',
  colPrize: 'Prize',
  colDrawTime: 'Draw Time',
  colDrawRegion: 'Draw Region',
  colAction: 'Action',
  // Actions
  detail: 'Detail',
  // Detail modal
  detailTitle: 'Draw Detail',
  sectionMemberInfo: 'Winner Info',
  sectionActivityInfo: 'Activity Info',
  sectionScanInfo: 'Scan Info',
  detailMemberId: 'User ID',
  detailMemberName: 'User Name',
  detailPhone: 'Phone',
  detailActivityId: 'Activity ID',
  detailActivityName: 'Activity Name',
  detailWinPrize: 'Prize',
  detailWinStrategy: 'Strategy',
  detailAwardStatus: 'Award Status',
  detailCode: 'QR Code',
  detailCodeBatch: 'Code Batch',
  detailProduct: 'Product',
  detailScanTime: 'Scan Time',
  detailScanRegion: 'Scan Country/Region',
  // Placeholder
  dash: '——',
  // Empty
  emptyText: 'No draw records',
};
